// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headerstyle
{
    background-color: #1f415b;
    color: white;
 
    height:60px;
}
.imgstyle
{
    background-color: #1f415b;
    width: 40px;
}
.header
{
    width: 100%;
    margin-left: 3px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
    background-color: #2c5778;
    border-radius: 16px;
    color: white;
    padding: 16px;
    display: flex;
    font-size: medium;
    font-weight: bold;
    justify-content: space-between;
    align-items: left;
}`, "",{"version":3,"sources":["webpack://./src/gitsubmodules/onboarding/src/pages/UserCreationForm.css"],"names":[],"mappings":"AAAA;;IAEI,yBAAyB;IACzB,YAAY;;IAEZ,WAAW;AACf;AACA;;IAEI,yBAAyB;IACzB,WAAW;AACf;AACA;;IAEI,WAAW;IACX,gBAAgB;IAChB,0CAA0C;IAC1C,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,iBAAiB;IACjB,iBAAiB;IACjB,8BAA8B;IAC9B,iBAAiB;AACrB","sourcesContent":[".headerstyle\n{\n    background-color: #1f415b;\n    color: white;\n \n    height:60px;\n}\n.imgstyle\n{\n    background-color: #1f415b;\n    width: 40px;\n}\n.header\n{\n    width: 100%;\n    margin-left: 3px;\n    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);\n    background-color: #2c5778;\n    border-radius: 16px;\n    color: white;\n    padding: 16px;\n    display: flex;\n    font-size: medium;\n    font-weight: bold;\n    justify-content: space-between;\n    align-items: left;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
